import React from 'react';
import GalleryView, { GalleryItem } from '../../components/Creative/GalleryView';
// Sample data for photography
const photoGalleryItems: GalleryItem[] = [{
  id: '1',
  imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Author Portrait Session',
  creator: 'Emma Roberts',
  price: 250,
  priceType: 'starting',
  serviceType: 'Portrait Session',
  genre: ['Professional'],
  description: 'Professional author portraits for your website, book jackets, and promotional materials.'
}, {
  id: '2',
  imageUrl: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Book Cover Photography',
  creator: 'Michael Chang',
  price: 350,
  priceType: 'fixed',
  serviceType: 'Cover Photography',
  genre: ['Multiple'],
  description: 'Custom photography specifically shot for your book cover concept.'
}, {
  id: '3',
  imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Social Media Package',
  creator: 'Emma Roberts',
  price: 175,
  priceType: 'fixed',
  serviceType: 'Social Media',
  genre: ['Multiple'],
  description: 'Set of coordinated images for your social media platforms and author brand.'
}, {
  id: '4',
  imageUrl: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Book Launch Event Coverage',
  creator: 'Michael Chang',
  price: 400,
  priceType: 'starting',
  serviceType: 'Event Photography',
  genre: ['Multiple'],
  description: 'Professional photography coverage of your book launch or signing event.'
}, {
  id: '5',
  imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Character Model Session',
  creator: 'Emma Roberts',
  price: 300,
  priceType: 'commissioned',
  serviceType: 'Character Photography',
  genre: ['Multiple'],
  description: "Photography session with models representing your book's characters."
}, {
  id: '6',
  imageUrl: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Location Photography',
  creator: 'Michael Chang',
  price: 275,
  priceType: 'starting',
  serviceType: 'Location Shots',
  genre: ['Multiple'],
  description: "Custom photography of locations that match your book's setting."
}, {
  id: '7',
  imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Product Photography',
  creator: 'Emma Roberts',
  price: 125,
  priceType: 'starting',
  serviceType: 'Product Photography',
  genre: ['Multiple'],
  description: 'Professional photos of your books and merchandise for online stores.'
}, {
  id: '8',
  imageUrl: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Atmospheric Scene Photography',
  creator: 'Michael Chang',
  price: 225,
  priceType: 'fixed',
  serviceType: 'Scene Photography',
  genre: ['Multiple'],
  description: "Moody, atmospheric photography that captures the essence of your book's themes."
}];
const PhotoGallery = () => {
  return <GalleryView items={photoGalleryItems} title="Photography Gallery" categoryName="Photography" data-id="element-8625" data-mp="c5l0lu92nits" />;
};
export default PhotoGallery;